// Mock data for development - with demo users for testing
export const mockUsers = [
  {
    id: 1,
    firstName: 'Demo',
    lastName: 'User',
    email: 'demo@rideburaq.com',
    password: 'password123',
    hasPayment: false,
    createdAt: new Date().toISOString()
  }
];

export const mockRides = [];

// Helper function to generate time slots for the next hour
export const generateTimeSlots = () => {
  const slots = [];
  const now = new Date();
  const nextHour = new Date(now.getTime() + 60 * 60 * 1000);
  
  // Generate 15-minute intervals for the next hour
  for (let i = 0; i < 4; i++) {
    const slotTime = new Date(now.getTime() + (i * 15 * 60 * 1000));
    if (slotTime < nextHour) {
      slots.push({
        value: slotTime.toISOString(),
        label: slotTime.toLocaleTimeString('en-US', { 
          hour: 'numeric', 
          minute: '2-digit',
          hour12: true 
        })
      });
    }
  }
  
  return slots;
};

// Vehicle classes: names, seats, bags and photos only. NO prices live in the website: every price comes from the server (POST /api/quote).
export const vehicleClasses = [
  {
    id: 'essential',
    name: 'Essential',
    description: 'Clean, newer sedans',
    carModels: '5 Series, E-Class, Audi A4 and similar',
    image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_65add0f0-f285-46f0-81a0-3fba94192f02/artifacts/zeew9our_ChatGPT%20Image%20Aug%2018%2C%202026%2C%2003_01_20%20AM.png',
    minHours: 2,
    maxPassengers: 3,
    maxBags: 2,
    luggage: '2 carry-ons or 2 checked bags',
    features: ['Premium Interior', 'Professional Driver', 'Complimentary Voss water']
  },
  {
    id: 'signature',
    name: 'Signature',
    description: 'Premium SUVs & crossovers',
    carModels: 'XT6, Lyriq, Aviator, MDX, Lexus RX and similar',
    image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_65add0f0-f285-46f0-81a0-3fba94192f02/artifacts/ge62lt7x_ChatGPT%20Image%20Aug%2018%2C%202026%2C%2003_02_56%20AM.png',
    minHours: 2,
    maxPassengers: 4,
    maxBags: 4,
    luggage: '4 carry-ons or 3 checked bags',
    features: ['Spacious Interior', 'Premium Sound System', 'Refreshments', 'Extra Luggage Space']
  },
  {
    id: 'majestic',
    name: 'Majestic',
    description: 'Full-size luxury SUVs',
    carModels: 'Suburban, Wagoneer, Yukon, Escalade, Navigator and similar',
    image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_65add0f0-f285-46f0-81a0-3fba94192f02/artifacts/uc313fsq_ChatGPT%20Image%20Aug%2018%2C%202026%2C%2003_07_24%20AM.png',
    minHours: 3,
    maxPassengers: 5,
    maxBags: 8,
    luggage: '8 carry-ons or 6 checked bags',
    features: ['First Class Experience', 'Executive Interior', 'Premium Refreshments', 'Concierge Service']
  },
  {
    id: 'reserve',
    name: 'Reserve',
    description: 'Ultra-luxury sedan · Mercedes-Benz S-Class',
    carModels: 'Mercedes-Benz S-Class',
    image: 'https://customer-assets-wrfwihn1.emergentagent.net/job_65add0f0-f285-46f0-81a0-3fba94192f02/artifacts/1vdnbtgu_ChatGPT%20Image%20Aug%2020%2C%202026%2C%2002_21_47%20PM.png',
    minHours: 3,
    maxPassengers: 3,
    maxBags: 3,
    luggage: '3 carry-ons or 2 checked bags',
    features: ['Flagship S-Class', 'White-Glove Service', 'Utmost Discretion']
  }
];

// Tri-State Area locations (NY, NJ, CT)
export const triStateLocations = [
  // New York
  { address: 'Manhattan, NY - Times Square', lat: 40.7580, lng: -73.9855, state: 'NY' },
  { address: 'Manhattan, NY - Central Park', lat: 40.7505, lng: -73.9934, state: 'NY' },
  { address: 'Manhattan, NY - Wall Street', lat: 40.7074, lng: -74.0113, state: 'NY' },
  { address: 'Brooklyn, NY - Downtown', lat: 40.6892, lng: -73.9442, state: 'NY' },
  { address: 'Queens, NY - LGA Airport', lat: 40.7769, lng: -73.8740, state: 'NY' },
  { address: 'Bronx, NY - Yankee Stadium', lat: 40.8296, lng: -73.9262, state: 'NY' },
  { address: 'Staten Island, NY', lat: 40.5795, lng: -74.1502, state: 'NY' },
  { address: 'White Plains, NY', lat: 41.0340, lng: -73.7629, state: 'NY' },
  { address: 'Yonkers, NY', lat: 40.9312, lng: -73.8988, state: 'NY' },
  
  // New Jersey
  { address: 'Newark, NJ - Downtown', lat: 40.7357, lng: -74.1724, state: 'NJ' },
  { address: 'Jersey City, NJ', lat: 40.7178, lng: -74.0431, state: 'NJ' },
  { address: 'Hoboken, NJ', lat: 40.7439, lng: -74.0323, state: 'NJ' },
  { address: 'Princeton, NJ', lat: 40.3573, lng: -74.6672, state: 'NJ' },
  { address: 'Atlantic City, NJ', lat: 39.3643, lng: -74.4229, state: 'NJ' },
  { address: 'Trenton, NJ', lat: 40.2206, lng: -74.7563, state: 'NJ' },
  { address: 'Morristown, NJ', lat: 40.7968, lng: -74.4815, state: 'NJ' },
  
  // Connecticut
  { address: 'Hartford, CT', lat: 41.7658, lng: -72.6734, state: 'CT' },
  { address: 'New Haven, CT', lat: 41.3083, lng: -72.9279, state: 'CT' },
  { address: 'Stamford, CT', lat: 41.0534, lng: -73.5387, state: 'CT' },
  { address: 'Bridgeport, CT', lat: 41.1865, lng: -73.1952, state: 'CT' },
  { address: 'Greenwich, CT', lat: 41.0267, lng: -73.6287, state: 'CT' },
  { address: 'Waterbury, CT', lat: 41.5582, lng: -73.0515, state: 'CT' }
];

// Popular destinations outside tri-state
export const popularDestinations = [
  { address: 'Philadelphia, PA', lat: 39.9526, lng: -75.1652, state: 'PA' },
  { address: 'Boston, MA', lat: 42.3601, lng: -71.0589, state: 'MA' },
  { address: 'Washington DC', lat: 38.9072, lng: -77.0369, state: 'DC' },
  { address: 'Baltimore, MD', lat: 39.2904, lng: -76.6122, state: 'MD' }
];

// Combined locations for dropdown
export const mockLocations = [...triStateLocations, ...popularDestinations];

// Helper function to check if at least one location is in tri-state
export const validateTriStateRule = (pickup, dropoff) => {
  const triStateStates = ['NY', 'NJ', 'CT'];
  const pickupLocation = mockLocations.find(loc => loc.address === pickup);
  const dropoffLocation = mockLocations.find(loc => loc.address === dropoff);
  
  if (!pickupLocation || !dropoffLocation) return false;
  
  return triStateStates.includes(pickupLocation.state) || triStateStates.includes(dropoffLocation.state);
};

// Calculate fare breakdown with tax
